import { render } from "./PaymentMethodList.vue?vue&type=template&id=4a567e6e"
import script from "./PaymentMethodList.vue?vue&type=script&lang=js"
export * from "./PaymentMethodList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__